import { render } from "./IconCar.vue?vue&type=template&id=daff7e5a"
import script from "./IconCar.vue?vue&type=script&lang=js"
export * from "./IconCar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__